import { FC } from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import styles from "../VacationsSickDaysViewEmployee.module.scss";

const DaysOffViewEmployeeCard: FC<any> = ({ title, vacationBalance, daysOff }) => {
    const { t } = useTranslation();

    const countDay = daysOff?.reduce(
        (countDay: any, item: any) => countDay + item.numberOfDaysOff,
        0,
    );

    const filteredDaysOff = daysOff?.filter(
        (day: any, index: number, self: any) =>
            index === self.findIndex((t: any) => t.startDate === day.startDate) && index !== -1
    ) || [];

    const daysOffCalculated = filteredDaysOff.reduce(
        (acc: number, item: any) => {
            return acc + (Number(item.pureDays) || 0);
        },
        0,
    );

    console.log(vacationBalance, 'vacationBalance');


    return (
        <div className={styles.card}>
            <div className={styles.boxCard_top}>
                <h4>{title}</h4>
                <div>{daysOffCalculated}</div>
            </div>
            {title === t("vacationsSickDays.Vacations") && (
                <div className={styles.boxCard_VacationDaysLeft}>
                    <h4>{t("vacationsSickDays.VacationDaysLeftForYear")}</h4>
                    <span>{vacationBalance}</span>
                </div>
            )}
            <ol className={styles.list}>
                {filteredDaysOff?.map((dayOff: any) => {
                    return (
                        <li key={dayOff.id}>
                            <p
                                className={
                                    dayOff.requestStatus === 4
                                        ? styles.redText
                                        : dayOff.requestStatus === 6
                                            ? styles.purpleText
                                            : undefined
                                }
                            >
                                {dayjs(dayOff.startDate).format("DD.MM.YYYY")}
                                {title === t("vacationsSickDays.DaysOff")
                                    ? ""
                                    : " - " +
                                    dayjs(dayOff.finishDate).format(
                                        "DD.MM.YYYY",
                                    )}
                                <b>( {dayOff.numberOfDaysOff} )</b>
                            </p>
                            <p
                                className={styles.list_remark}
                                style={
                                    dayOff.requestStatus === 4
                                        ? { color: "#dc3545" }
                                        : dayOff.requestStatus === 6
                                            ? { color: "purple" }
                                            : {}
                                }
                            >
                                {dayOff.remark}
                            </p>
                        </li>
                    );
                })}
            </ol>
        </div>
    );
};

export default DaysOffViewEmployeeCard;
